import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Avatar from '../assits/Profile.avif'
import axios from 'axios'
import Moment from 'react-moment';
import 'moment-timezone';
import { BASE_URL } from '../contexts/UserContext'


const PostAuthor = ({userId}) => {
  const [user, setUser] = useState({})

  useEffect(() => {
    const getUserDetailes = async () => {
    try {
        const {data} = await axios.get(`${BASE_URL}/users/user-details/${userId}`);
        setUser(data.user);
        
      }
      catch (error) {
      }
    } 
    getUserDetailes();
  },[userId])
  
  return (
    <Link to={`/userprofile/${userId}`} className='post__author'>
      <div className="post__author-avatar">
        <img src={ user?.profile?.secure_url || Avatar} alt="" />
      </div>
      <div className="post__author-details">
        <h5>By: {user.name}</h5>
        <small>{<Moment fromNow ago date={user?.createdAt} />}</small>
      </div>
    </Link>
  )
}

export default PostAuthor